import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Invoice, InvoiceCategory } from '../../model/invoice';
import { InvoiceService } from '../../service/data/invoice.service';
import { IncorrectPaymentService } from '../../service/data/incorrect-payment.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { IncorrectPayment } from '../../model/incorrect-payment';
import { SelectionItem } from '../../../core/component/select/select.component';
import { of, Subscription } from 'rxjs';
import { LeaseAgreementService } from '../../../rent/service/data/lease-agreement.service';
import { LocalDate } from '../../../core/model/local-date';
import { ContactService } from '../../../rent/service/data/contact.service';
import { AutoCompleteModel } from '../../../core/component/autocomplete/autocomplete-model';
import { finalize, switchMap } from 'rxjs/operators';
import { TenantService } from '../../../rent/service/data/tenant.service';

@Component({
    selector: 'app-add-contact-balance-form',
    templateUrl: './add-contact-balance-form.component.html',
    styleUrls: ['./add-contact-balance-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddContactBalanceFormComponent implements OnInit, OnDestroy {
  constructor(
    private _actionService: ActionWindowService,
    private _paymentService: IncorrectPaymentService,
    private _leaseAgreementService: LeaseAgreementService,
    public filterService: TenantService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    this.form = fb.group({
      amount: fcf.createMandatory('INCORRECT_PAYMENT.AMOUNT', 0),
      businessTransactionDate: fb.group({}),
      contact: fcf.createMandatory('COMMON.CONTACT', null),
      leaseAgreementId: fcf.create('INCORRECT_PAYMENT.LEASE', null),
    });
  }

  ngOnDestroy(): void {
    if (this._sub) {
      this._sub.unsubscribe();
    }
    if (this._submitSub) {
      this._submitSub.unsubscribe();
    }
  }

  @Input() dataContext: IncorrectPayment;

  form: FormGroup;
  invoices: Invoice[];

  cancel() {
    this._actionService.close();
  }

  private _sub: Subscription;
  private _submitSub: Subscription;

  leaseAgreements: SelectionItem[] = [];
  contacts: AutoCompleteModel[] = [];
  accountingDate: LocalDate;

  ngOnInit() {
    this.accountingDate = LocalDate.fromDate(this.dataContext.businessTransactionDate);
    this.form.controls['contact'].setValue(this.dataContext.payer);
    this.form.controls['amount'].setValue(this.dataContext.balance);
    this._sub = this.form.controls['contact'].valueChanges
      .pipe(
        switchMap(value => {
          if (!value || typeof value !== 'string') {
            return of([] as SelectionItem[]);
          }
          return this._leaseAgreementService.getByPayerSelection(value);
        })
      )
      .subscribe(value => {
        this.form.controls['leaseAgreementId'].setValue(null);
        this.leaseAgreements = value;
      });
  }

  private working: boolean = false;
  onSubmit() {
    if (this.form.invalid || this.working) return;

    this.working = true;
    this._submitSub = this._paymentService
      .addToContactBalance(
        this.form.value.amount,
        this.dataContext.id,
        this.form.value.contact,
        this.form.value.leaseAgreementId,
        this.accountingDate
      )
      .pipe(
        finalize(() => {
          this.working = false;
        })
      )
      .subscribe(payment => {
        this._actionService.complete(payment);
      });
  }
}
